// extracted by mini-css-extract-plugin
module.exports = {"root":"CallHistory_root__1G6WF","header":"CallHistory_header__1TK8Z","col":"CallHistory_col__1zP3J","downloadBtn":"CallHistory_downloadBtn__3Pc_H"};